module.exports = __webpack_public_path__ + "img/WEHOTEL.c5849454.png";